module.exports = __webpack_public_path__ + "static/media/allalerts_train.83034fc6.svg";